import {useMemo} from 'react';
import trim from 'lodash/trim';

import CurrencyInput from '@/components/form/currency-input';
import {DocumentInputField} from '@/engine/types';
import {useDocumentLocale} from '../../hooks/use-document-locale';
import {FieldProps} from '../../meta-field';

const trimInputValue = (value: string = '') => {
  return value.includes('.') ? trim(value, '0') : value;
};

const normalizeStoredValue = (value: string) => {
  const [integerPart, fractionPart] = value.split('.');
  if (!fractionPart) return integerPart;
  return `${integerPart}.${fractionPart.padEnd(2, '0')}`;
};

export const CurrencyField = ({
  field,
  value,
  handleBlur,
  handleFocus,
  handleChange,
}: FieldProps<DocumentInputField>) => {
  const {_t} = useDocumentLocale();

  const updatedValue = useMemo(() => trimInputValue(value === '' ? undefined : value), [value]);

  return (
    <CurrencyInput
      data-testid={`${field.id}_input`}
      maxLength={field.maxLength}
      name={field.id}
      onAccept={value => handleChange(normalizeStoredValue(value))}
      onBlur={handleBlur}
      onFocus={handleFocus}
      placeholder={_t(field.placeholder)}
      readOnly={field.readonly}
      required={field.required}
      type={field.type}
      value={updatedValue}
    />
  );
};
